import React, { useMemo } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import cc from 'classnames';

import styles from './Loader.module.css';

// will be changed when side-menu will be merged
import logo from 'assets/img/fab_logo_letter.svg';

type LoaderType = {
  hide?: boolean;
  size?: number;
  fullHeight?: boolean;
  className?: string,
};

function Loader({ hide, size = 48, fullHeight, className }: LoaderType) {
  const imgStyle = useMemo(() => (size < 25 ? { width: 12, height: 'auto' } : {}), [size]);

  return (
    <div className={cc(styles.container, { [styles.removed]: hide }, { [styles.fullheight]: fullHeight }, className)}>
      <CircularProgress variant="indeterminate" size={size} thickness={1} />
      <img src={logo} alt="fab-logo" className={styles.logo} style={imgStyle} />
    </div>
  );
}

export default Loader;
